<template>
  <div class="text-center pa-4 pb-2">
    <div class="d-flex flex-column gap-2" v-if="!qrCode">
      <v-img
        src="@/assets/images/brands/pix.svg"
        width="210"
        height="120"
        contain
        class="mx-auto my-6"
      />
      <v-alert color="success" dense text border="bottom" class="mb-0 mt-2">
        <v-icon size="16" class="mr-2" color="success">mdi-lock</v-icon>
        Pague com Pix de forma rápida e segura.
      </v-alert>
      <!-- <v-icon size="100" class="py-8">mdi-qrcode-scan</v-icon> -->

      <v-btn color="primary" @click="pay" :loading="loading" large depressed>
        Pagar com PIX • {{ payment.amount | currency(true) }}
      </v-btn>
      <small class="text--secondary wrap-balance">
        Não será possível alterar o método de pagamento após a confirmação.
      </small>
    </div>
    <template v-else-if="payment.status != 'succeeded'">
      <div class="d-flex justify-center">
        <qrcode-vue
          :value="qrCode.text"
          style="
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=);
            background-size: cover;
          "
          class="d-flex justify-center pa-4 white rounded mt-2"
          size="230"
          level="M"
        />
      </div>

      <div class="justify-center d-flex flex-column align-center gap-1 mb-4 mt-2">
        <h4 class="mb-0">{{ payment.amount | currency(true) }}</h4>
        <v-progress-linear
          v-if="payment.status === 'pending'"
          indeterminate
          color="primary"
          class="rounded"
          stream
          buffer-value="0"
          style="width: 160px !important"
        ></v-progress-linear>
        <span class="font-weight-bold"> Aguardando pagamento </span>
        <span class="text--secondary">
          Este código expira em <b>{{ remainingTime | formatTime }}</b>
        </span>
      </div>

      <v-text-field
        v-model="qrCode.text"
        outlined
        dense
        readonly
        label="PIX copia e cola"
        class="text-center"
        :color="(copied && 'success') || undefined"
        hide-details
        @focus="selectAll"
      >
      </v-text-field>

      <v-btn
        color="primary"
        block
        :disabled="copied"
        class="mt-1"
        @click="copy"
        small
        depressed
      >
        <v-icon x-small left v-if="!copied">mdi-content-copy</v-icon>
        <v-icon x-small left v-else>mdi-check</v-icon>
        {{ copied ? "Código copiado" : "Copiar código Pix" }}
      </v-btn>

      <small>
        Escaneie o QR Code ou copie e cole o código Pix para efetuar o pagamento.
      </small>
    </template>
    <v-fab-transition v-else>
      <div class="pa-4">
        <v-icon size="60" color="success"> mdi-check-circle </v-icon>
        <h4 class="mt-2">Pagamento Aprovado</h4>
      </div>
    </v-fab-transition>
    <div class="d-flex justify-center mt-2">
      <v-btn text @click="close" small :disabled="loading"> Fechar </v-btn>
    </div>
  </div>
</template>

<script>
import TICKET from "@/services/app/ticket";
import QrcodeVue from "qrcode.vue";
import moment from "moment";

export default {
  components: { QrcodeVue },
  data: () => ({
    loading: false,
    qrCode: false,
    copied: false,
  }),
  methods: {
    async pay() {
      try {
        this.loading = true;
        const { data } = await TICKET.pay(this.paymentId, {
          type: "PIX",
        });

        this.qrCode = data.qrCode;
        this.$emit("lock", "PIX");
        this.$emit("update");
        this.updateInterval();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    copy() {
      if (!this.qrCode || this.copied) return;
      navigator.clipboard.writeText(this.qrCode.text);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
    updateInterval() {
      if (this.interval) clearInterval(this.interval);
      if (this.payment.status === "succeeded") return;
      this.interval = setInterval(() => {
        this.$emit("update");
      }, 15000);
    },
    close() {
      this.$emit("close");
    },
    selectAll(e) {
      e.target.select();
    },
  },
  watch: {
    payment(val, old) {
      if (val.status === "succeeded" && old.status !== "succeeded") {
        this.$emit("refresh");

        this.$root.$emit("purchase", {
          amount: this.payment?.amount,
          paymentId: this.paymentId,
          paymentMethod: this.payment?.paymentMethod,
          paymentType: this.payment?.paymentType,
          Tickets: this.tickets,
        });

        clearInterval(this.interval);
        this.$confetti.start();
        setTimeout(() => {
          this.$confetti.stop();
        }, 5000);
      }
    },
  },
  filters: {
    formatTime(time) {
      let formt = "mm:ss";
      if (time > 60 * 60 * 1000) formt = "HH:mm:ss";
      if (time > 24 * 60 * 60 * 1000) formt = "DD [dias] HH:mm:ss";

      return moment.utc(time).format(formt);
    },
  },
  mounted() {
    if (this.payment.paymentType !== "PIX") return;
    this.qrCode = this.integrationData.qrCode;
    this.updateInterval();
  },
  props: {
    paymentId: {
      type: String,
      required: true,
    },
    payment: {
      type: Object,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
    integrationData: {
      type: Object,
      default: () => ({}),
    },
    remainingTime: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style></style>
